import { XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { PersonnelData } from '../types';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface AllPersonaltableProps {
  data?: PersonnelData[];
}

const customColors = [
  'rgba(0, 81, 0, 1)',
  'rgba(38, 144, 0, 1)',
  'rgba(203, 229, 78, 1)',
  'rgba(255, 202, 2, 1)',
  'rgba(241, 133, 1, 1)',
  'rgba(93, 149, 234, 1)',
];

export const AllPersonaltable: React.FC<AllPersonaltableProps> = ({ data = [] }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];

  const filteredData = lastThreeYears.map(year => 
    data.find(item => item.year === year) || {
      year,
      countPolitical: 0,
      countAdministrative: 0,
      countTop: 0,
      countNonState: 0,
      countMiddle: 0,
      countOther: 0,
    }
  );

  const chartData = filteredData.map(item => ({
    год: item.year.toString(),
    'Политические должности': item.countPolitical,
    'Административные госслужащие': item.countAdministrative,
    'ТОП': item.countTop,
    'Не государственные служащие': item.countNonState,
    'МОП': item.countMiddle,
    'Иные': item.countOther,
  }));

  return (
    <div className={styles.container}>
      <div className={styles.chartContainer}>
        <h2 className={styles.title}>Общее количество сотрудников</h2>
        <ResponsiveContainer>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="год" tick={{ fill: '#000000' }} />
            <YAxis tick={{ fill: '#000000' }} />
            <Tooltip 
              contentStyle={{
                background: '#fff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '4px 4px 4px 4px rgba(0, 0, 0, 0.1)',
                padding: '10px',
                color: '#000000'
              }}
            />
            <Legend 
              wrapperStyle={{
                fontSize: '13px',
                color: '#000000'
              }}
              iconSize={10}
              iconType="circle"
              verticalAlign="bottom"
              align="center"
            />
            <Bar barSize={60} dataKey="Политические должности" fill={customColors[0]} stackId="a" />
            <Bar barSize={60} dataKey="Административные госслужащие" fill={customColors[1]} stackId="a" />
            <Bar barSize={60} dataKey="ТОП" fill={customColors[2]} stackId="a" />
            <Bar barSize={60} dataKey="Не государственные служащие" fill={customColors[3]} stackId="a" />
            <Bar barSize={60} dataKey="МОП" fill={customColors[4]} stackId="a" />
            <Bar barSize={60} dataKey="Иные" fill={customColors[5]} stackId="a" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
